import * as React from "react";
import { forwardRef } from "react";
const SvgIcDataInfo24StatusOk = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM10.9053 15.4912L7.20703 11.793L5.79297 13.207L10.0859 17.5H11.8779L19.4033 7.82422L17.8242 6.59668L10.9053 15.4912Z", fill: "#13A813" }));
const ForwardRef = forwardRef(SvgIcDataInfo24StatusOk);
export { ForwardRef as ReactComponent };
